export const NINJA_HIGHLIGHT_IDS = [160104, 160111, 160105];
export function ninjaHighlights<T extends { iid:number }>(items:T[]):T[] {
  return NINJA_HIGHLIGHT_IDS.map(id=>items.find(item=>item.iid===id)).filter((item):item is T=>!!item);
}
